<template>
  <div>
    <div id="floatingBarPositioner"></div>
    <div :class="{ isFloatingBar: isFloatingBar }" id="floatingBarWrapper">
      <div class="floating-bar">
        <!-- Ancres vers les différentes sections de l'écran -->
        <ul class="anchors">
          <li
            v-for="anchor in anchors"
            :key="anchor.name"
            class="nav-btn"
            :class="{ selected: anchor === selectedAnchor }"
            @click="scrollToAnchor(anchor)"
          >
            {{ $t("views.themeView.floatingBar.anchors." + anchor.name) }}
          </li>
        </ul>

        <!-- Choix du nb de colonnes à afficher simultanément -->
        <div class="columns">
          <span
            class="columnsMenuTitle"
            href="#"
            v-html="$t('views.themeView.floatingBar.columns.title')"
          ></span>

          <ul class="columnsOptions">
            <li
              v-for="nb in nbMaxColumns"
              :key="nb"
              class="rect-container"
              :class="{ selected: nb == nbDisplayedColumns }"
              :title="
                $tc('views.themeView.floatingBar.columns.tooltip', nb, [nb])
              "
              @click="setNbDisplayedColumns(nb)"
            >
              <span class="rect" v-for="i in nb" :key="i"></span>
              <span class="number">{{ nb }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FloatingBar",
  data: function() {
    return {
      anchors: [
        {
          name: "observations",
          restoreScrollPosition: true,
          lastScrollPosition: null
        },
        {
          name: "objectifications",
          restoreScrollPosition: true,
          lastScrollPosition: null
        },
        {
          name: "analyse",
          restoreScrollPosition: false
        },
        {
          name: "progressProposals",
          restoreScrollPosition: false
        }
      ],

      selectedAnchor: null,

      isFloatingBar: false
      
    };
  },
  computed: {
    nbDisplayedColumns: function() {
      return this.$store.state.appState.themesColumns.nbDisplayedColumns;
    },
    nbMaxColumns: function() {
      return this.$store.state.appState.themesColumns.nbMaxColumns;
    }
  },
  created: function() {
    this.selectedAnchor = this.anchors[0];
    document.addEventListener("scroll", this.handleScrollAndResize);
    window.addEventListener("resize", this.handleScrollAndResize);
  },
  mounted: function() {
    this.handleScrollAndResize();
  },
  destroyed: function() {
    document.removeEventListener("scroll", this.handleScrollAndResize);
    window.addEventListener("resize", this.handleScrollAndResize);
  },
  methods: {
    /**
     * Change le nombre de colonnes à afficher simultanément.
     * @param {number} nb - Nb de colonnes
     */
    setNbDisplayedColumns: function(nb) {
      this.$store.dispatch("setNbDisplayedColumns", nb);
      this.lastScrollPositions = [];
    },
    handleScrollAndResize: function() {
      // On ne fait rien si la barre flottante n'est pas disponible
      var floatingBarWrapper = $("#floatingBarWrapper"); //eslint-disable-line no-undef
      if (!floatingBarWrapper.length) {
        return;
      }

      let yOffset = window.pageYOffset;

      this.isFloatingBar =
        yOffset > $("#floatingBarPositioner").offset().top + 2; //eslint-disable-line no-undef

      this.floatingBarHeight = floatingBarWrapper.height();
      $("#floatingBarPositioner").height( //eslint-disable-line no-undef
        this.isFloatingBar ? this.floatingBarHeight : 0
      );

      // Sélection auto de l'onglet
      if (!this.isScrolling) {
        var selAnchor = null;
        for (var i = 0; i < this.anchors.length; i++) {
          var anchor = this.anchors[i];
          var sectionY = $("#" + anchor.name).offset().top; //eslint-disable-line no-undef
          if (yOffset >= sectionY - this.floatingBarHeight - 30) {
            selAnchor = anchor;
          }
        }
        if (selAnchor) {
          if (selAnchor.restoreScrollPosition) {
            selAnchor.lastScrollPosition = null;
          }

          // Activation de l'ancre
          this.selectedAnchor = selAnchor;
        }
      }
    },

    scrollToAnchor: function(anchor) {
      var that = this;
      let offsetY = this.floatingBarHeight + 5;

      if (
        anchor !== this.selectedAnchor &&
        this.selectedAnchor.restoreScrollPosition
      ) {
        // Mémorisation de la position de scroll pour l'ancre actuellement activée
        this.selectedAnchor.lastScrollPosition = Math.max(
          window.pageYOffset,
          $("#" + this.selectedAnchor.name).offset().top - offsetY //eslint-disable-line no-undef
        );
      }

      // Détermination de la position vers laquelle scroller
      var scrollPosY = $("#" + anchor.name).offset().top - offsetY; //eslint-disable-line no-undef
      if (
        anchor !== this.selectedAnchor &&
        anchor.restoreScrollPosition &&
        anchor.lastScrollPosition !== null
      ) {
        scrollPosY = anchor.lastScrollPosition;
      }

      this.isScrolling = true;
      that.selectedAnchor = anchor;
      $("html,body") //eslint-disable-line no-undef
        .stop()
        .animate(
          {
            scrollTop: Math.floor(scrollPosY)
          },
          500,
          function() {
            $("html,body").scrollTop(scrollPosY); //eslint-disable-line no-undef
            that.isScrolling = false;
          }
        );
    }
  }
};
</script>

<style lang="sass" scoped>
@import "../../sass/_variables.sass"
@import "../../sass/_media.sass"

.floating-bar
  display: flex
  justify-content: space-between
  background-color: white
  padding: 0
  user-select: none

  @media (max-width: 720px) 
    flex-direction: column
    align-items: start

  .anchors
    display: flex
    align-items: flex-start
    list-style: none
    margin: 0
    padding: 0
    font-family: pt_sans, Arial, "Helvetica Neue", Helvetica, sans-serif
    font-size: 1.38em
    font-weight: normal
    color: #000 !important

    @media (max-width: 590px) 
      font-size: 1.1em

    .nav-btn
      color: black
      background-color: $lightgray-1
      font-size: 1em
      padding: 0.3em 0.8em
      border: 2px solid white
      cursor: pointer
      word-break: break-word
      hyphens: auto

      &.selected
        background-color: $lightgray-3

      a
        color: black !important
        padding: 0.3em 0.6em

        &:hover
          color: black
          text-decoration: underline
        

  .columns
    display: flex
    align-items: center
    margin: 0
    padding: 0

    .columnsMenuTitle
      text-align: right
      font-size: 0.9em
      margin-right: 0.5em
      @media (max-width: 830px) 
        display: none
      @media (max-width: 720px) 
        display: block
        margin-left: 0.5em

    ul
      display: flex
      align-items: center
      list-style: none
      margin: 0
      padding: 0

      li
        display: inline-flex
        align-items: center
        padding: 0
        margin: 0 0.4em
        cursor: pointer

        .rect
          display: inline-block
          width:8px
          height:20px
          background-color: $lightgray-1
          border: 1px solid white
          font-size: 0

        .number
          margin-left: 0.1em

        &.selected
          cursor: default 

          .rect
            background-color: $darkgray-3   
   
.isFloatingBar 
  position: fixed
  top: 0
  left: 0
  width: 100%
  z-index: 100

  .floating-bar
    max-width: 900px
    padding: 1px 0
    box-shadow: 0px 1px 2px rgba(0,0,0,0.5)
    margin: auto

</style>